namespace appn.views.reports.preview {
    class InitArgs {
        previewUrl: string = emptyString;
        reportId: string = emptyString;
        reportType: string = emptyString;
    }

    interface ReportParameterDef {
        Name: string;
        Kind: string | number;
        HintText?: string;
        PlaceholderText?: string;
        IsOptional?: boolean;
        Value?: string;
        Values?: string[];
        Options?: { [key: string]: string };
    }

    let _initArgs: InitArgs;
    let _dataTable: any = null;

    export function init(args: InitArgs): void {
        _initArgs = args;
        renderParameters();
        addFilterEvents();
        createDataTable();
    }

    function createDataTable() {
        _dataTable = appn.dataTable.create('.dataTable', {
            sAjaxSource: _initArgs.previewUrl || 'Reports/PreviewDataTable',
            fnServerData: function (data: any) {
                data.push(
                    { name: 'sCustom_0', value: _initArgs.reportId },
                    { name: 'sCustom_1', value: _initArgs.reportType }
                );
                
                // Add parameter names and values in alternating pairs
                const paramValues = getParameterValues();
                let customIndex = 2;
                paramValues.forEach((param) => {
                    data.push({ name: `sCustom_${customIndex}`, value: param.name });
                    data.push({ name: `sCustom_${customIndex + 1}`, value: param.value });
                    customIndex += 2;
                });
            },
            autoWidth: false,
            aaSorting: [[1, 'desc']],
            aoColumns: buildColumns(),
            fnInitComplete: function () {
                appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));
                appn.dataTable.addSearchPlaceholder(T('Filter preview results...'));
            }
        });
    }

    function buildColumns(): any[] {
        const ths = $('.dataTable thead th');
        const cols: any[] = [];
        ths.each(function (idx) {
            cols.push({ bSortable: false });
        });
        return cols;
    }

    function renderParameters(): void {
        const paramsForSelection: ReportParameterDef[] = getInitialParams();
        const $container = $('#report-parameters-preview');
        $container.empty();

        if (!paramsForSelection || paramsForSelection.length === 0)
            return;

        paramsForSelection.forEach((p, idx) => {
            const inputId = `rp_preview_${idx}`;

            // Label with compact styling matching Feed view
            const label = $('<label/>')
                .attr('for', inputId)
                .addClass('px-0 pt-0')
                .text(p.Name || '');

            const $row = $('<div/>').addClass('form-group form-row mb-1 mx-0');

            if (isTextKind(p.Kind)) {
                const $input = $('<input/>')
                    .attr('type', 'text')
                    .addClass('form-control form-control-sm')
                    .attr('id', inputId)
                    .attr('name', `ReportParameters[${idx}].Value`)
                    .attr('placeholder', p.PlaceholderText || '')
                    .val(p.Value || '');

                applyRequiredIfNeeded($input, p);
                $row.append(label).append($input);
            }
            else if (isIntegerKind(p.Kind)) {
                const $input = $('<input/>')
                    .attr('type', 'number')
                    .attr('step', '1')
                    .addClass('form-control form-control-sm')
                    .attr('id', inputId)
                    .attr('name', `ReportParameters[${idx}].Value`)
                    .attr('placeholder', p.PlaceholderText || '')
                    .val(p.Value || '');

                applyRequiredIfNeeded($input, p);
                $row.append(label).append($input);
            }
            else if (isDecimalKind(p.Kind)) {
                const $input = $('<input/>')
                    .attr('type', 'number')
                    .attr('step', 'any') // Use 'any' to allow floating-point numbers
                    .addClass('form-control form-control-sm')
                    .attr('id', inputId)
                    .attr('name', `ReportParameters[${idx}].Value`)
                    .attr('placeholder', p.PlaceholderText || '')
                    .val(p.Value || '');

                applyRequiredIfNeeded($input, p);
                $row.append(label).append($input);
            }
            else if (isBooleanKind(p.Kind)) {
                const $row = $('<div/>').addClass('form-group form-row mb-1 mx-0');
                const inputId = `rp_preview_${idx}`;

                const $hiddenFalse = $('<input/>')
                    .attr('type', 'hidden')
                    .attr('name', `ReportParameters[${idx}].Value`)
                    .val('false');

                const $checkbox = $('<input/>')
                    .attr('type', 'checkbox')
                    .attr('id', inputId)
                    .attr('name', `ReportParameters[${idx}].Value`)
                    .val('true')
                    .prop('checked', p.Value === 'true');

                const $wrapper = $('<div/>')
                    .addClass('icheck-primary')
                    .addClass('appn-checkbox');

                const $checkLabel = $('<label/>').attr('for', inputId).text(p.Name || '');

                $wrapper.append($checkbox).append($checkLabel);
                $row.append($hiddenFalse).append($wrapper);

                $container.append($row);
            }
            else if (isDateKind(p.Kind)) {
                const $group = $('<div/>').addClass('input-group date datetimepicker');
                const $input = $('<input/>')
                    .attr('type', 'text')
                    .addClass('form-control form-control-sm')
                    .attr('id', inputId)
                    .attr('name', `ReportParameters[${idx}].Value`)
                    .attr('placeholder', p.PlaceholderText || '')
                    .val(p.Value || '');
                applyRequiredIfNeeded($input, p);

                const $icon = $('<i/>').addClass('fa fa-calendar fa-xs');
                const $btn = $('<button/>').attr('type', 'button').addClass('input-group-text btn btn-secondary').append($icon);
                const $append = $('<div/>').addClass('input-group-append input-group-addon').append($btn);

                $group.append($input).append($append);
                $row.append(label).append($group);

                // Initialize the dynamic Date picker to ensure proper behavior/format
                setTimeout(() => {
                    try {
                        // Assuming a parallel datePicker function exists
                        if (appn.ui && (appn.ui as any).datePicker) {
                            (appn.ui as any).datePicker($group);
                        }
                    } catch (e) {
                        console.log('DatePicker initialization failed:', e);
                    }
                }, 100);
            }
            else if (isDateTimeKind(p.Kind)) {
                // Build the same structure as Appn().DateTimePicker / DatePickerFor
                const $group = $('<div/>').addClass('input-group date datetimepicker');
                const $input = $('<input/>')
                    .attr('type', 'text')
                    .addClass('form-control form-control-sm')
                    .attr('id', inputId)
                    .attr('name', `ReportParameters[${idx}].Value`)
                    .attr('placeholder', p.PlaceholderText || '')
                    .val(p.Value || '');
                applyRequiredIfNeeded($input, p);

                const $icon = $('<i/>').addClass('fa fa-calendar fa-xs');
                const $btn = $('<button/>').attr('type', 'button').addClass('input-group-text btn btn-secondary').append($icon);
                const $append = $('<div/>').addClass('input-group-append input-group-addon').append($btn);

                $group.append($input).append($append);
                $row.append(label).append($group);

                // Initialize the dynamic DateTime picker to ensure proper behavior/format
                setTimeout(() => {
                    try { 
                        if (appn.ui && (appn.ui as any).dateTimePicker) {
                            (appn.ui as any).dateTimePicker($group);
                        }
                    } catch (e) { 
                        console.log('DateTimePicker initialization failed:', e);
                    }
                }, 100);
            }
            else if (isTimeKind(p.Kind)) {
                // Build the same structure as Appn().TimePicker
                const $group = $('<div/>').addClass('input-group timepicker');
                const $input = $('<input/>')
                    .attr('type', 'text')
                    .addClass('form-control form-control-sm')
                    .attr('id', inputId)
                    .attr('name', `ReportParameters[${idx}].Value`)
                    .attr('placeholder', p.PlaceholderText || '')
                    .val(p.Value || '');
                applyRequiredIfNeeded($input, p);

                const $icon = $('<i/>').addClass('fa fa-clock fa-xs');
                const $btn = $('<button/>').attr('type', 'button').addClass('input-group-text btn btn-secondary').append($icon);
                const $append = $('<div/>').addClass('input-group-append input-group-addon').append($btn);

                $group.append($input).append($append);

                // This line correctly appends the shared label and the new group to the shared row
                $row.append(label).append($group);

                // Initialize the dynamic Time picker
                setTimeout(() => {
                    try {
                        if (appn.ui && (appn.ui as any).timePicker) {
                            (appn.ui as any).timePicker($group);
                        }
                    } catch (e) {
                        console.log('TimePicker initialization failed:', e);
                    }
                }, 100);
            }
            else if (isDateRangeKind(p.Kind)) {
                // Parse existing DateRange value
                let dateRangeData: any = {};
                try {
                    if (p.Value) {
                        dateRangeData = JSON.parse(p.Value);
                    }
                } catch (e) {
                    dateRangeData = { RangeType: 'ThisMonth', FromDate: null, ToDate: null };
                }

                // Create dropdown for date range selection
                const $select = $('<select/>')
                    .attr('id', inputId + '_select')
                    .addClass('form-control form-control-sm appn-daterange-select')
                    .attr('data-param-index', idx);

                // Add range options similar to DataDateFilter enum
                const rangeOptions = [
                    { value: 'All', text: 'All' },
                    { value: 'Today', text: 'Today' },
                    { value: 'Last7Days', text: 'Last 7 Days' },
                    { value: 'ThisMonth', text: 'This Month' },
                    { value: 'LastMonth', text: 'Last Month' },
                    { value: 'Last6Months', text: 'Last 6 Months' },
                    { value: 'Last12Months', text: 'Last 12 Months' },
                    { value: 'CustomRange', text: 'Custom Range' }
                ];

                rangeOptions.forEach(option => {
                    const $option = $('<option/>')
                        .attr('value', option.value)
                        .text(option.text);
                    
                    if (dateRangeData.RangeType === option.value) {
                        $option.attr('selected', 'selected');
                    }
                    
                    $select.append($option);
                });

                // Create custom date range container (initially hidden)
                const $customContainer = $('<div/>')
                    .addClass('container-custom-filter container-fluid mb-3 mt-2 px-0')
                    .attr('id', inputId + '_custom')
                    .css('display', dateRangeData.RangeType === 'CustomRange' ? 'block' : 'none');

                // From date picker
                const $fromGroup = $('<div/>').addClass('input-group date datepicker mb-2');
                const $fromInput = $('<input/>')
                    .attr('type', 'text')
                    .addClass('form-control form-control-sm')
                    .attr('id', inputId + '_from')
                    .attr('placeholder', 'From Date')
                    .val(dateRangeData.FromDate || '');

                const $fromIcon = $('<i/>').addClass('fa fa-calendar fa-xs');
                const $fromBtn = $('<button/>').attr('type', 'button').addClass('input-group-text btn btn-secondary').append($fromIcon);
                const $fromAppend = $('<div/>').addClass('input-group-append input-group-addon').append($fromBtn);
                $fromGroup.append($fromInput).append($fromAppend);

                // To date picker
                const $toGroup = $('<div/>').addClass('input-group date datepicker');
                const $toInput = $('<input/>')
                    .attr('type', 'text')
                    .addClass('form-control form-control-sm')
                    .attr('id', inputId + '_to')
                    .attr('placeholder', 'To Date')
                    .val(dateRangeData.ToDate || '');

                const $toIcon = $('<i/>').addClass('fa fa-calendar fa-xs');
                const $toBtn = $('<button/>').attr('type', 'button').addClass('input-group-text btn btn-secondary').append($toIcon);
                const $toAppend = $('<div/>').addClass('input-group-append input-group-addon').append($toBtn);
                $toGroup.append($toInput).append($toAppend);

                $customContainer.append($fromGroup).append($toGroup);

                // Hidden field to store the actual JSON value
                const $hiddenValue = $('<input/>')
                    .attr('type', 'hidden')
                    .attr('id', inputId)
                    .attr('name', `ReportParameters[${idx}].Value`)
                    .val(p.Value || '');

                $row.append(label).append($select).append($customContainer).append($hiddenValue);

                // Add event handler for dropdown change
                $select.on('change', function() {
                    const selectedRange = $(this).val() as string;
                    const $custom = $(`#${inputId}_custom`);
                    const $hidden = $(`#${inputId}`);
                    
                    if (selectedRange === 'CustomRange') {
                        $custom.show();
                    } else {
                        $custom.hide();
                        // Update hidden field with predefined range
                        const rangeData = {
                            RangeType: selectedRange,
                            FromDate: null,
                            ToDate: null
                        };
                        $hidden.val(JSON.stringify(rangeData));
                    }
                });

                // Add event handlers for custom date changes
                $fromInput.add($toInput).on('change', function() {
                    const fromDate = $(`#${inputId}_from`).val();
                    const toDate = $(`#${inputId}_to`).val();
                    const $hidden = $(`#${inputId}`);
                    
                    const rangeData = {
                        RangeType: 'CustomRange',
                        FromDate: fromDate,
                        ToDate: toDate
                    };
                    $hidden.val(JSON.stringify(rangeData));
                });

                // Initialize date pickers for custom dates
                setTimeout(() => {
                    try {
                        // Use the existing appn.ui.datePicker approach
                        if (appn.ui && (appn.ui as any).datePicker) {
                            (appn.ui as any).datePicker($fromGroup);
                            (appn.ui as any).datePicker($toGroup);
                        }
                    } catch (e) {
                        console.log('DateRange DatePicker initialization failed:', e);
                    }
                }, 100);

                applyRequiredIfNeeded($hiddenValue, p);
            }
            else if (isSelectKind(p.Kind)) {
                // Create Select dropdown with Select2 styling
                const $select = $('<select/>')
                    .addClass('form-control form-control-sm select2-noinit')
                    .attr('id', inputId)
                    .attr('name', `ReportParameters[${idx}].Value`);

                // Add placeholder option if parameter is optional
                if (p.IsOptional) {
                    const $placeholderOption = $('<option/>')
                        .attr('value', '')
                        .text(p.PlaceholderText || 'Select an option...');
                    $select.append($placeholderOption);
                }

                // Add options from Options dictionary (preferred) or fallback to Values array
                if (p.Options && Object.keys(p.Options).length > 0) {
                    // Use Options dictionary: key = actual value, value = display text
                    Object.keys(p.Options).forEach(optionKey => {
                        const displayText = p.Options![optionKey];
                        const $option = $('<option/>')
                            .attr('value', optionKey)
                            .text(displayText);
                        
                        if (p.Value === optionKey) {
                            $option.attr('selected', 'selected');
                        }
                        
                        $select.append($option);
                    });
                }

                applyRequiredIfNeeded($select, p);
                $row.append(label).append($select);

                // Initialize Select2 after a short delay to ensure DOM is ready
                setTimeout(() => {
                    try {
                        if (($select as any).select2) {
                            ($select as any).select2({
                                theme: 'bootstrap4',
                                allowClear: p.IsOptional,
                                placeholder: p.PlaceholderText || 'Select an option...'
                            });
                        }
                    } catch (e) {
                        console.log('Select2 initialization failed:', e);
                    }
                }, 100);
            }
            else if (isMultiSelectKind(p.Kind)) {
                // Create MultiSelect dropdown with Select2 styling and multiple selection
                const $select = $('<select/>')
                    .addClass('form-control form-control-sm select2-noinit')
                    .attr('id', inputId)
                    .attr('name', `ReportParameters[${idx}].Value`)
                    .attr('multiple', 'multiple');

                // Parse existing JSON array value for pre-selection
                let selectedValues: string[] = [];
                try {
                    if (p.Value) {
                        selectedValues = JSON.parse(p.Value);
                        if (!Array.isArray(selectedValues)) {
                            selectedValues = [];
                        }
                    }
                } catch (e) {
                    selectedValues = [];
                }

                // Add options from Options dictionary (preferred) or fallback to Values array
                if (p.Options && Object.keys(p.Options).length > 0) {
                    // Use Options dictionary: key = actual value, value = display text
                    Object.keys(p.Options).forEach(optionKey => {
                        const displayText = p.Options![optionKey];
                        const $option = $('<option/>')
                            .attr('value', optionKey)
                            .text(displayText);
                        
                        if (selectedValues.includes(optionKey)) {
                            $option.attr('selected', 'selected');
                        }
                        
                        $select.append($option);
                    });
                }

                applyRequiredIfNeeded($select, p);
                $row.append(label).append($select);

                // Initialize Select2 with multiple selection after a short delay to ensure DOM is ready
                setTimeout(() => {
                    try {
                        if (($select as any).select2) {
                            ($select as any).select2({
                                theme: 'bootstrap4',
                                allowClear: p.IsOptional,
                                placeholder: p.PlaceholderText || 'Select options...',
                                multiple: true
                            });
                        }
                    } catch (e) {
                        console.log('MultiSelect Select2 initialization failed:', e);
                    }
                }, 100);
            }

            // Add hidden field for Kind
            const kindName = toEnumName(p.Kind);
            const $hiddenKind = $('<input/>')
                .attr('type', 'hidden')
                .attr('name', `ReportParameters[${idx}].Kind`)
                .val(kindName);
            $row.append($hiddenKind);

            $container.append($row);
        });
    }

    function addFilterEvents(): void {
        $(document).on('click', '#apply-filters-btn', function() {
            refreshDataTable();
        });

        $(document).on('click', '#export-preview-btn', function() {
            exportPreviewData();
        });
    }

    function refreshDataTable(): void {
        if (_dataTable) {
            _dataTable.fnDraw();
        }
    }

    function exportPreviewData(): void {
        // Create a form dynamically to POST the parameter data
        const $form = $('<form/>')
            .attr('method', 'POST')
            .attr('action', 'ExportPreviewData')
            .css('display', 'none');

        // Add report ID and type as hidden fields for ViewModel binding
        $form.append($('<input/>').attr('type', 'hidden').attr('name', 'Id').val(_initArgs.reportId));
        $form.append($('<input/>').attr('type', 'hidden').attr('name', 'Type').val(_initArgs.reportType));

        // Get parameter values and add them as hidden fields for ViewModel Parameters dictionary
        const paramValues = getParameterValues();
        paramValues.forEach((param) => {
            $form.append($('<input/>')
                .attr('type', 'hidden')
                .attr('name', `Parameters[${param.name}]`)
                .val(param.value));
        });

        // Append form to body, submit it, and remove it
        $('body').append($form);
        $form.submit();
        $form.remove();
    }

    function getParameterValues(): any[] {
        const params: any[] = [];
        const paramsForSelection: ReportParameterDef[] = getInitialParams();

        $('#report-parameters-preview input[name*=".Value"], #report-parameters-preview select[name*=".Value"]').each(function() {
            const $this = $(this);

            // If this is a hidden input that is part of a boolean checkbox pair,
            // skip it. The actual checkbox value will be processed correctly.
            if ($this.attr('type') === 'hidden') {
                const $nextCheckboxWrapper = $this.next('.icheck-primary');
                if ($nextCheckboxWrapper.length > 0 && $nextCheckboxWrapper.find('input[type="checkbox"]').attr('name') === $this.attr('name')) {
                    return; // Continue to next iteration
                }
            }

            const name = $this.attr('name') || '';
            let value: any;

            if ($this.attr('type') === 'checkbox') {
                value = $this.prop('checked').toString();
            } else if ($this.attr('type') === 'hidden') {
                // For DateRange parameters, the hidden field contains the JSON value
                const indexMatch = name.match(/\[(\d+)\]/);
                if (indexMatch) {
                    const paramIndex = parseInt(indexMatch[1]);
                    const param = paramsForSelection[paramIndex];
                    if (param && isDateRangeKind(param.Kind)) {
                        // For DateRange, get the current state from UI elements
                        const inputId = `rp_preview_${paramIndex}`;
                        const selectedRange = $(`#${inputId}_select`).val() as string;
                        const fromDate = $(`#${inputId}_from`).val();
                        const toDate = $(`#${inputId}_to`).val();

                        // Always preserve the FromDate and ToDate values from the inputs
                        value = JSON.stringify({
                            RangeType: selectedRange,
                            FromDate: fromDate,
                            ToDate: toDate
                        });

                        // Update the hidden field with the current value
                        $this.val(value);
                    } else {
                        value = $this.val();
                    }
                }
            } else {
                // Check if this is a MultiSelect parameter
                const indexMatch = name.match(/\[(\d+)\]/);
                if (indexMatch) {
                    const paramIndex = parseInt(indexMatch[1]);
                    const param = paramsForSelection[paramIndex];
                    if (param && isMultiSelectKind(param.Kind)) {
                        // For MultiSelect, get array of selected values and convert to JSON
                        const selectedValues = $this.val() as string[] || [];
                        value = JSON.stringify(selectedValues);
                    } else {
                        value = $this.val();
                    }
                } else {
                    value = $this.val();
                }
            }

            if (name.includes('.Value')) {
                // Extract the parameter index from the name
                const indexMatch = name.match(/\[(\d+)\]/);
                if (indexMatch) {
                    const paramIndex = parseInt(indexMatch[1]);
                    const paramName = paramsForSelection[paramIndex]?.Name || `param_${paramIndex}`;
                    params.push({ name: paramName, value: value });
                }
            }
        });
        return params;
    }

    function getInitialParams(): ReportParameterDef[] {
        const $hidden = $('#report-params-preview');
        if ($hidden.length === 0)
            return [];
        const val = ($hidden.val() as string) || '';
        if (!val || !val.trim())
            return [];
        try {
            return JSON.parse(val) as ReportParameterDef[];
        } catch (e) {
            return [];
        }
    }

    // Helper functions from ViewReport.ts
    function applyRequiredIfNeeded($el: JQuery<HTMLElement>, p: ReportParameterDef): void {
        if (!p || !p.IsOptional) {
            $el.attr('required', 'required').attr('aria-required', 'true');
        }
    }

    function isTextKind(kind: string | number): boolean {
        if (typeof kind === 'number')
            return kind === 0;
        if (!kind)
            return false;
        return (kind as string).toLowerCase() === 'text';
    }

    function isIntegerKind(kind: string | number): boolean {
        if (typeof kind === 'number')
            return kind === 1;
        if (!kind)
            return false;
        return (kind as string).toLowerCase() === 'integer' || (kind as string).toLowerCase() === 'int';
    }

    function isDecimalKind(kind: string | number): boolean {
        if (typeof kind === 'number')
            return kind === 2;
        if (!kind)
            return false;
        const k = (kind as string).toLowerCase();
        return k === 'decimal' || k === 'number' || k === 'float' || k === 'double';
    }

    function isBooleanKind(kind: string | number): boolean {
        if (typeof kind === 'number')
            return kind === 3;
        if (!kind)
            return false;
        const k = (kind as string).toLowerCase();
        return k === 'boolean' || k === 'bool';
    }
    
    function isDateKind(kind: string | number): boolean {
        if (typeof kind === 'number')
            return kind === 4;
        if (!kind)
            return false;
        return (kind as string).toLowerCase() === 'date';
    }

    function isDateRangeKind(kind: string | number): boolean {
        if (typeof kind === 'number')
            return kind === 5;
        if (!kind)
            return false;
        return (kind as string).toLowerCase() === 'daterange';
    }

    function isTimeKind(kind: string | number): boolean {
        if (typeof kind === 'number')
            return kind === 6;
        if (!kind)
            return false;
        return (kind as string).toLowerCase() === 'time';
    }

    function isDateTimeKind(kind: string | number): boolean {
        if (typeof kind === 'number')
            return kind === 7;
        if (!kind)
            return false;
        return (kind as string).toLowerCase() === 'datetime';
    }

    function isSelectKind(kind: string | number): boolean {
        if (typeof kind === 'number')
            return kind === 8;
        if (!kind)
            return false;
        return (kind as string).toLowerCase() === 'select';
    }

    function isMultiSelectKind(kind: string | number): boolean {
        if (typeof kind === 'number')
            return kind === 9;
        if (!kind)
            return false;
        return (kind as string).toLowerCase() === 'multiselect' || (kind as string).toLowerCase() === 'multi-select';
    }

    function toEnumName(kind: string | number): string {
        if (typeof kind === 'string') {
            const k = kind.trim();
            const l = k.toLowerCase();
            if (l === 'datetime') return 'DateTime';
            if (l === 'daterange') return 'DateRange';
            if (l === 'multiselect' || l === 'multi-select') return 'MultiSelect';
            if (l === 'number' || l === 'float' || l === 'double') return 'Decimal';
            if (l === 'bool') return 'Boolean';
            return k.charAt(0).toUpperCase() + k.slice(1);
        }
        const map = ['Text','Integer','Decimal','Boolean','Date','DateRange','Time','DateTime','Select','MultiSelect'];
        return map[kind] ?? 'Text';
    }
}
